import { render, staticRenderFns } from "./QuotasList.vue?vue&type=template&id=3cf5e5ca&"
import script from "./QuotasList.vue?vue&type=script&lang=ts&"
export * from "./QuotasList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports